import { FieldLabel, LabelText, Optional, StyledInput } from "./styles";

interface FieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  optional?: boolean;
  type?: string;
  maxLength?: number;
}

export default function Field({
  label,
  value,
  onChange,
  placeholder,
  optional,
  type = "text",
  maxLength,
}: FieldProps) {
  return (
    <FieldLabel>
      <LabelText>
        {label}
        {optional && <Optional> · opcional</Optional>}
      </LabelText>
      <StyledInput
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        type={type}
        maxLength={maxLength}
      />
    </FieldLabel>
  );
}
